// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2fYuJ","subheader":"ReorderModal_subheader__3Gmos","listWrap":"ReorderModal_listWrap__2T6GT"};